import { forwardRef } from 'react';

import { VpIcon, VpIconButton } from '@vtmn-play/react';
import clsx from 'clsx';
import { CSSTransition } from 'react-transition-group';

import { SnackbarProps } from './Snackbar.props';

import './Snackbar.scss';

const Snackbar = forwardRef<HTMLDialogElement, SnackbarProps>(
  (
    {
      closeButtonLabel,
      id,
      isOpen,
      onClose,
      onExited,
      title,
      ...props
    }: SnackbarProps,
    ref,
  ) => (
    <CSSTransition
      appear
      classNames='snackbar-transition'
      in={isOpen}
      nodeRef={ref}
      onExited={onExited}
      timeout={400}
      unmountOnExit
    >
      <dialog
        {...props}
        aria-labelledby={`${id}-title`}
        className={clsx('snackbar', props?.className)}
        ref={ref}
      >
        <div className='snackbar-header'>
          <div className='grow' id={`${id}-title`}>
            {title}
          </div>

          <VpIconButton
            aria-label='close'
            className='snackbar-icon'
            onClick={onClose}
            size='small'
            type='button'
            variant='tertiary'
            variantStyle='inverse'
          >
            <VpIcon aria-label={closeButtonLabel} name='close' />
          </VpIconButton>
        </div>
        {props.children}
      </dialog>
    </CSSTransition>
  ),
);

export default Snackbar;
